import React, { Fragment, ReactNode } from "react"

import Modal from '@/Components/Modal/Modal'

import './OptionsDialog.scss'

export interface Option {
  icon?: ReactNode
  label: string
  color?: string
  active?: boolean
  disabled?: boolean
  divider?: boolean
  onClick: () => void
}

export interface OptionsDialogProps {
  show: boolean
  closeButton?: boolean
  title: string
  options: Option[]
  onHide: () => void
}

const OptionsDialog = (props: OptionsDialogProps) => {

  return (
    <Modal
      show={props.show}
      title={props.title}
      onClose={props.onHide}
      showCloseButton
      size="sm"
      centered
      backdropClassName="options-dialog-backdrop"
      className="options-dialog"
    >
      <div className="options-dialog-list">
        {props.options.map((option: Option, index: number) => (
          <Fragment key={index}>
            {option.divider && <div className="option-divider" role="separator" />}
            <button
              className={`option-item${option.active ? ' active' : ''}${option.color ? ' option-item--danger' : ''}`}
              onClick={() => {
                option.onClick()
                props.onHide()
              }}
              style={{
                color: option.color
              }}
              disabled={option.disabled}
            >
              <div className="icon">
                {option.icon}
              </div>
              <div className="text">
                {option.label}
              </div>
            </button>
          </Fragment>
        ))}
      </div>
    </Modal>
  )
}

export default OptionsDialog
